/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import BaseEditorComponent from 'cio/components/condition-list/edit/base';

export default class Segments extends BaseEditorComponent {
  // external API
  condition = null;
  disabled = false;
  dropdownInitiallyOpened = false;

  segments = null;
  variation = null;
  onApply() {}

  // internal API
  selectedSegments = null;

  init() {
    super.init(...arguments);

    let { condition, segments } = this.getProperties('condition', 'segments');

    let selectedSegments = condition.segments
      ? condition.segments.map((segmentId) => {
          let segment = segments.findBy('value', segmentId.toString());
          return segment;
        })
      : [];

    this.setProperties({
      selectedSegments,
    });
  }

  @action
  _onApply() {
    let segments = this.get('selectedSegments').map((segment) => parseInt(segment.value));

    return this.onApply({
      type: 'segments',
      segments,
    });
  }

  @action
  onSelectedSegmentsChange(newSegments) {
    this.set('selectedSegments', newSegments);
  }
}
